module.exports = __webpack_public_path__ + "static/media/id_member_front.e019c491.jpg";